// extracted by mini-css-extract-plugin
export default {"languageMenuDesktop":"languageMenu_languageMenuDesktop__PImgG","language":"languageMenu_language__40m-s","languageMenuMobile":"languageMenu_languageMenuMobile__LOT7b"};